import 'angular-modal-service';

module.exports = angular.module(__filename, [
    require('data/settings/program-service').name,
    'angularModalService'

]).controller('cloneProgramController',
    ['$scope', '$rootScope', '$transitions', 'program', 'close', 'programService', 'notificator', '$q',
        function ($scope, root, $transitions, program, close, programService, notificator, $q) {
            $scope.close = close;
            $scope.program = program;
            $scope.newName = '';

            // close modal on navigate back
            var closeListener = $transitions.onStart({}, function() {
                close({reload: false});
            });
            $scope.$on('$destroy', function() {
                if (closeListener && typeof closeListener === 'function') {
                    closeListener();
                }
            });

            $scope.save = function () {
                programService.cloneProgram($scope.program.id, $scope.newName).then(
                    function (data) {
                        root.user.programs.push(programService.buildProgram(data));
                        notificator.success({body: 'Program cloned successfully'});
                        close({reload: true});
                    }
                );
            }
        }
    ]
);
